import { Icon, Modal, ModalBody, ModalHeader, Button } from "design-react-kit";

const FileExistMessageModal = ({
  modalOpen,
  modalCloseHandler,
  uploadFileHandler,
  getFileAnalysisResultHandler,
  data,
  documentAnalysisResultId,
}) => {
  const denyReplaceHandler = () => {
    getFileAnalysisResultHandler(documentAnalysisResultId);
    modalCloseHandler();
  };

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="fileExistMessage"
    >
      <ModalHeader
        toggle={modalCloseHandler}
        id="fileExistMessage"
      ></ModalHeader>
      <ModalBody className="text-center">
        <div className="mb-3">
          <Icon icon="it-info-circle" color="warning" />
          <h5 className="d-inline font-weight-bold ml-2">Attenzione!</h5>
        </div>
        <p className="mb-3 font-weight-normal">
          Un file con lo stesso nome è già stato fornito ed è disponibile
          nell'elenco; effettua nuovamente l'upload (consumera un servizio AI di
          AWS) solo se il contenuto è variato. <br />
          Procedi con l'upload?
        </p>
        <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-around">
          <Button
            color="white"
            className="mr-2"
            onClick={(e) => denyReplaceHandler()}
            id="user-cancel"
          >
            No
          </Button>
          <Button
            color="warning"
            onClick={(e) => {
              modalCloseHandler();
              uploadFileHandler(data.clientId, data.file);
            }}
          >
            Sì
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FileExistMessageModal;
